import { useCallback } from 'react'
import { API_BASE } from '../lib/config'
import { ENDPOINTS } from '../lib/endpoints'

export const useGoogleLogin = () => {
  const login = useCallback(() => {
    const returnTo = window.location.pathname + window.location.search
    const url = new URL(`${API_BASE}${ENDPOINTS.auth.google}`)
    if (returnTo && returnTo !== '/') {
      url.searchParams.set('returnTo', returnTo)
    }
    window.location.href = url.toString()
  }, [])

  return { login }
}
